import clsx from 'clsx'
import {FC, useState} from 'react'
import {capitalize} from 'lodash'
import {Loader} from '_core/components/Loader'
import {KTSVG} from '_metronic/helpers'
import {showMessage} from 'app/redux/messageSlice'
import {useDispatch} from 'react-redux'
import {Button} from '_core'

type Props = {
  payment: any
  onPaymentChange: (payment: any) => void
  paymentMethodId: string
  checkedPaymentMethodId: string
  address: any
  onValidate: (id: string) => void
  onPrimary: (id: string) => void
}
const PaymentMethodListItem: FC<Props> = ({
  payment,
  onPaymentChange,
  checkedPaymentMethodId,
  paymentMethodId,
  address,
  onPrimary,
  onValidate,
}) => {
  const [isSubmitting, setSubmitting] = useState(false)
  const [isPrimary, setIsSubmitting] = useState(false)

  const dispatch = useDispatch()

  const handleSelectPrimary = async () => {
    try {
      setIsSubmitting(true)
      await onPrimary(payment.id)
    } finally {
      setIsSubmitting(false)
    }
  }

  const handleChange = async () => {
    try {
      setSubmitting(true)
      const isValid: any = await onValidate(payment.id)
      if (isValid) {
        onPaymentChange(payment)
      } else {
        dispatch(showMessage({text: 'Payment method is not valid.', variant: 'error'}))
      }
    } catch (error) {
      console.error(error)
      dispatch(
        showMessage({text: 'Error occurred while selecting payment method.', variant: 'error'})
      )
    } finally {
      setSubmitting(false)
    }
  }
  return (
    <>
      <label
        className={clsx(
          'd-flex flex-stack mb-7 cursor-pointer border-3 border rounded py-3',
          paymentMethodId === payment?.id ? 'border-primary-active bg-light-primary' : '',
          payment.isPrimary && 'justify-content-between'
        )}
      >
        <div className='d-flex align-items-center me-2'>
          {checkedPaymentMethodId !== payment?.id ? (
            <div className='form-check form-check-custom form-check-solid form-check-primary me-6'>
              <input
                className='form-check-input'
                type='radio'
                checked={paymentMethodId === payment?.id}
                value={payment.id}
                onChange={handleChange}
              />
            </div>
          ) : (
            <div className='me-3'>
              <KTSVG
                path='/media/icons/duotune/arrows/arr016.svg'
                className='svg-icon-muted svg-icon-1'
              />
            </div>
          )}
          <div className='fs-6 fw-bold'>
            <span className='fw-bolder'>{`${capitalize(payment.card.brand)} **** ${
              payment.card.last4
            }`}</span>

            <br />
            {`${payment.card.expMonth}/${payment.card.expYear}`}
            {address && (
              <div className='fs-6 fw-bold pt-4'>
                {address.addressLine1}
                <div>{address.addressLine2}</div>
                <div>{`${address.city}, ${address.state.code} ${address.zipCode}, ${address.country.code}`}</div>
              </div>
            )}
            <br />
            {!payment.isPrimary && (
              <Button
                id='btnAddressPrimary'
                type='button'
                isSubmitting={isPrimary}
                className='btn btn-sm btn-transparent m-0 p-0 text-decoration-underline bg-white'
                onClick={handleSelectPrimary}
                title='Set as primary'
              />
            )}
          </div>
        </div>
        {payment.isPrimary && (
          <div>
            <span className={`badge badge badge-light-success ms-2`}>Primary</span>
          </div>
        )}
      </label>
      {isSubmitting && (
        <div className='position-relative'>
          <Loader show={isSubmitting} />
        </div>
      )}
    </>
  )
}
export default PaymentMethodListItem
